/**
 * @module icons
 */

/**
 * Defines all icons for the VIM component.
 * @packageDocumentation
 */

import React from 'react'

/**
 * Common Icon Options.
 */
export type IconOptions = {
  height: number | string
  width: number | string
  fill: string
  className?: string
}

// Common
export function settings ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        d="M110.325,241.773c-2.567,7.495-10.811,11.566-18.271,9.145l-7.218-2.346c-7.522-2.44-11.739-10.548-9.41-18.133l.849-2.764c1.939-6.314-.798-14.567-6.152-18.465l-1.461-1.066c-5.339-3.882-14.046-3.953-19.452-.162l-2.369,1.662c-6.48,4.553-15.542,3.001-20.158-3.341l-4.466-6.136c-4.652-6.397-3.246-15.472,3.037-20.195l2.314-1.741c5.28-3.965,7.913-12.249,5.864-18.552l-.557-1.722c-2.038-6.279-9.043-11.455-15.646-11.563l-2.894-.047c-7.913-.13-14.334-6.709-14.334-14.552v-7.593c0-7.909,6.476-14.425,14.334-14.552l2.894-.047c6.602-.107,13.6-5.264,15.646-11.566l.557-1.718c2.041-6.279-.584-14.587-5.864-18.555l-2.314-1.738c-6.33-4.758-7.649-13.852-3.037-20.195l4.466-6.14c4.656-6.393,13.73-7.854,20.158-3.341l2.369,1.662c5.406,3.795,14.093,3.736,19.452-.162l1.461-1.062c5.335-3.882,8.091-12.151,6.152-18.465l-.849-2.768c-2.326-7.57,1.951-15.708,9.41-18.129l7.218-2.346c7.522-2.444,15.7,1.639,18.271,9.142l.94,2.74c2.144,6.247,9.209,11.313,15.835,11.313h1.805c6.602,0,13.69-5.066,15.831-11.313l.94-2.74c2.571-7.491,10.816-11.563,18.275-9.141l7.218,2.346c7.522,2.44,11.739,10.544,9.41,18.129l-.849,2.768c-1.939,6.314,.798,14.567,6.152,18.465l1.461,1.062c5.339,3.886,14.046,3.957,19.448,.162l2.369-1.662c6.48-4.549,15.546-2.997,20.158,3.341l4.47,6.14c4.652,6.397,3.246,15.472-3.037,20.195l-2.314,1.738c-5.28,3.969-7.913,12.253-5.868,18.555l.561,1.718c2.038,6.282,9.043,11.459,15.646,11.566l2.891,.047c7.917,.126,14.334,6.709,14.334,14.552v7.593c0,7.905-6.476,14.425-14.334,14.552l-2.891,.047c-6.602,.107-13.6,5.26-15.646,11.563l-.561,1.722c-2.038,6.279,.588,14.587,5.868,18.552l2.314,1.741c6.33,4.758,7.649,13.852,3.037,20.195l-4.47,6.136c-4.652,6.397-13.726,7.858-20.158,3.341l-2.369-1.662c-5.402-3.791-14.09-3.736-19.448,.162l-1.461,1.066c-5.335,3.882-8.091,12.151-6.152,18.465l.849,2.764c2.326,7.574-1.951,15.712-9.41,18.133l-7.218,2.346c-7.522,2.44-15.7-1.639-18.275-9.145l-.94-2.736c-2.14-6.247-9.205-11.313-15.831-11.313h-1.805c-6.602,0-13.69,5.066-15.835,11.313l-.94,2.736Zm17.674-45.77c37.559,0,68.002-30.443,68.002-68.002s-30.443-67.998-68.002-67.998-67.998,30.443-67.998,67.998,30.443,68.002,67.998,68.002Z"
      />
    </svg>
  )
}

export function help ({ height, width, fill, className }: IconOptions) {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 256 256"
      className={className}
    >
      <path
        fill={fill}
        d="M128 0C57.308 0 0 57.308 0 128s57.308 128 128 128 128-57.308 128-128S198.692 0 128 0Zm0 232c-57.346 0-104-46.654-104-104S70.654 24 128 24s104 46.654 104 104-46.654 104-104 104Z"
      />
      <path
        fill={fill}
        d="M124.365 160.615c-8.46 1.295-15.374 8.209-16.669 16.669-2.079 13.576 9.446 25.101 23.021 23.021 8.46-1.295 15.374-8.209 16.669-16.669 2.079-13.576-9.446-25.101-23.021-23.021ZM163.386 68.844a52.951 52.951 0 0 0-33.074-12.25c-17.985-.747-34.607 7.896-45.516 21.957-3.202 4.128-2.75 9.046 1.601 13.371 3.147 3.129 6.892 5.802 6.892 5.802a10.286 10.286 0 0 0 14.183-1.691l.484-.593a24.146 24.146 0 0 1 20.212-10.412c8.988 0 19.032 5.926 19.032 13.781 0 5.114-3.414 8.161-9.31 11.713l-7.809 4.456a30.622 30.622 0 0 0-19.201 27.423v1.118a8.773 8.773 0 0 0 8.773 8.774h15.771a8.773 8.773 0 0 0 8.773-8.774c0-4.486 4.9-7.319 11.117-10.902a37.039 37.039 0 0 0 23.519-33.533 39.43 39.43 0 0 0-15.45-30.241Z"
      />
    </svg>
  )
}

export function trash ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        d="M117.317 197.644v-95.33c0-5.467-3.715-10.632-9.129-11.395-6.591-.929-12.238 4.163-12.238 10.574v95.329c0 5.468 3.715 10.633 9.129 11.396 6.591.929 12.238-4.163 12.238-10.574ZM160.05 197.644v-95.33c0-5.467-3.715-10.632-9.129-11.395-6.591-.929-12.238 4.163-12.238 10.574v95.329c0 5.468 3.715 10.633 9.129 11.396 6.591.929 12.238-4.163 12.238-10.574ZM232 42.734h-39.68V10.995C192.32 4.923 187.397 0 181.325 0H74.995C68.923 0 64 4.923 64 10.995v31.739H24c-8.837 0-16 7.163-16 16v.05c0 8.837 7.163 16 16 16h208c8.837 0 16-7.163 16-16v-.05c0-8.837-7.163-16-16-16Zm-66.389-14.025v14.025H90.709V28.709a2 2 0 0 1 2-2h70.902a2 2 0 0 1 2 2Z"
      />
      <path
        fill={fill}
        d="M183.95 207.924c0 8.85-7.175 16.025-16.025 16.025H88.076c-8.85 0-16.025-7.175-16.025-16.025V98.81a8 8 0 0 0-8-8h-16.05a8 8 0 0 0-8 8v114.456c0 23.601 19.133 42.734 42.734 42.734h90.532c23.601 0 42.734-19.133 42.734-42.734V98.81a8 8 0 0 0-8-8h-16.05a8 8 0 0 0-8 8v109.115Z"
      />
    </svg>
  )
}

export function checkmark ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        d="M228.693 61.741c5.379-7.011 4.057-17.055-2.954-22.434-7.01-5.379-17.054-4.057-22.434 2.954l-.008.011L99.864 177.069l-39.607-47.203c-5.68-6.769-15.772-7.652-22.542-1.972s-7.652 15.772-1.972 22.542l52.416 62.467.006.007c.018.021.038.039.056.06.214.252.448.492.681.733.153.159.3.326.458.478s.331.291.497.437c.251.222.5.445.763.648l.062.053c.108.083.225.151.334.231.304.221.608.44.924.638.166.104.335.192.503.289.284.164.567.328.859.473.221.11.447.204.671.303.245.107.487.219.736.313.268.103.54.188.812.275.214.069.428.142.645.202.293.081.588.144.884.208.206.044.411.093.619.129.294.051.589.085.884.12.219.026.437.055.656.071.275.021.55.026.825.033.245.006.489.015.735.009.246-.005.491-.024.736-.042.274-.018.548-.036.821-.068.22-.026.437-.065.654-.101.293-.047.585-.094.876-.158.207-.045.41-.103.615-.157.292-.076.584-.152.873-.245.215-.069.425-.152.637-.23.267-.099.535-.196.798-.31.245-.105.483-.228.723-.346.219-.108.44-.211.656-.331.286-.158.562-.334.839-.511.163-.104.328-.199.488-.31.307-.211.603-.444.896-.678.106-.085.219-.157.324-.245.021-.018.039-.038.06-.056.253-.215.492-.449.733-.681.159-.153.326-.301.478-.458.152-.159.292-.332.438-.498.221-.25.444-.5.647-.761.017-.022.037-.041.054-.063L228.693 61.741Z"
      />
    </svg>
  )
}

export function undo ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        d="M167.055,76.799H56.971l27.112-27.112c4.687-4.687,4.687-12.285,0-16.971h0c-4.686-4.687-12.284-4.687-16.97,0L19.515,80.313c-4.686,4.687-4.686,12.285,0,16.971h0s0,0,0,0l47.598,47.598c4.686,4.686,12.284,4.686,16.97,0s4.687-12.284,0-16.971l-27.112-27.113h111.029c12.742,0,24.774,5.015,33.879,14.121,9.106,9.105,14.121,21.138,14.121,33.879s-5.015,24.774-14.121,33.879c-9.105,9.106-21.138,14.121-33.879,14.121h-60c-6.627,0-12,5.373-12,12h0c0,6.627,5.373,12,12,12h60c39.925,0,72.531-32.933,71.994-72.975-.531-39.538-33.397-71.025-72.938-71.025Z"
      />
    </svg>
  )
}

export function close ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        d="m150.627 128 68.686-68.687c6.249-6.248 6.249-16.379 0-22.627-6.248-6.249-16.379-6.249-22.627 0l-68.687 68.686-68.686-68.685c-6.248-6.249-16.379-6.249-22.627 0-6.249 6.248-6.249 16.379 0 22.627l68.686 68.687-68.685 68.686c-6.249 6.248-6.249 16.379 0 22.627 6.248 6.249 16.379 6.249 22.627 0l68.687-68.686 68.687 68.686c6.248 6.249 16.379 6.249 22.627 0 6.249-6.248 6.249-16.379 0-22.627L150.629 128Z"
      />
    </svg>
  )
}

export function home ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M247.312 97.494 140.194 15.107C136.599 12.342 132.3 10.96 128 10.96s-8.6 1.382-12.194 4.147L8.688 97.494c-5.254 4.039-6.24 11.573-2.201 16.827s11.573 6.24 16.827 2.201l.687-.528v109.731c0 11.046 8.954 20 20 20h49.16c11.046 0 20-8.954 20-20v-51.726a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v51.726c0 11.046 8.954 20 20 20h46.84c11.046 0 20-8.954 20-20v-109.73l.687.528c5.254 4.039 12.789 3.053 16.827-2.201s3.054-12.788-2.201-16.827ZM208 221.726h-38.84V166c0-13.255-10.745-24-24-24h-32c-13.255 0-24 10.745-24 24v55.726H48V97.547l80-61.541 80 61.542v124.179Z"
      />
    </svg>
  )
}

export function fullsScreen ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        d="M136,36c0,6.627,5.373,12,12,12h43.03s-51.515,51.515-51.515,51.515c-4.686,4.687-4.686,12.284,0,16.971,4.686,4.686,12.284,4.686,16.971,0l51.515-51.515v43.029c0,6.627,5.373,12,12,12,6.627,0,12-5.373,12-12V36c0-3.071-1.172-6.142-3.515-8.485-2.343-2.343-5.414-3.515-8.485-3.515h-72c-6.627,0-12,5.373-12,12Z"
      />
      <path
        fill={fill}
        d="M120,220c0-6.627-5.373-12-12-12h-43.03s51.515-51.515,51.515-51.515c4.686-4.687,4.686-12.284,0-16.971-4.686-4.686-12.284-4.686-16.971,0l-51.515,51.515v-43.029c0-6.627-5.373-12-12-12s-12,5.373-12,12v72c0,3.071,1.172,6.142,3.515,8.485,2.343,2.343,5.414,3.515,8.485,3.515H108c6.627,0,12-5.373,12-12Z"
      />
    </svg>
  )
}

export function minimize ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M232 108c0-6.627-5.373-12-12-12h-43.03l51.515-51.515c4.686-4.687 4.686-12.284 0-16.971-4.686-4.686-12.284-4.686-16.971 0l-51.515 51.515V36c0-6.627-5.373-12-12-12s-12 5.373-12 12v72c0 3.071 1.172 6.142 3.515 8.485a11.963 11.963 0 0 0 8.485 3.515h72c6.627 0 12-5.373 12-12ZM24 148c0 6.627 5.373 12 12 12h43.03l-51.515 51.515c-4.686 4.687-4.686 12.284 0 16.971 4.686 4.686 12.284 4.686 16.971 0l51.515-51.515V220c0 6.627 5.373 12 12 12s12-5.373 12-12v-72c0-3.071-1.172-6.142-3.515-8.485a11.963 11.963 0 0 0-8.485-3.515H36c-6.627 0-12 5.373-12 12Z"
      />
    </svg>
  )
}

export function treeView ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        d="M160 140h17.834c5.097 16.228 20.256 28 38.166 28 22.091 0 40-17.909 40-40s-17.909-40-40-40c-17.91 0-33.069 11.772-38.166 28H160V52h17.834C182.931 68.228 198.09 80 216 80c22.091 0 40-17.909 40-40S238.091 0 216 0c-17.91 0-33.069 11.772-38.166 28H156c-11 0-20 9-20 20v68h-24V92c0-11-9-20-20-20H20C9 72 0 81 0 92v72c0 11 9 20 20 20h72c11 0 20-9 20-20v-24h24v68c0 11 9 20 20 20h21.834c5.097 16.228 20.256 28 38.166 28 22.091 0 40-17.909 40-40s-17.909-40-40-40c-17.91 0-33.069 11.772-38.166 28H160v-64Zm56-28c8.822 0 16 7.178 16 16s-7.178 16-16 16-16-7.178-16-16 7.178-16 16-16Zm0-88c8.822 0 16 7.178 16 16s-7.178 16-16 16-16-7.178-16-16 7.178-16 16-16ZM88 160H24V96h64v64Zm128 40c8.822 0 16 7.178 16 16s-7.178 16-16 16-16-7.178-16-16 7.178-16 16-16Z"
      />
    </svg>
  )
}
export function more ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} fill={fill} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        d="M48,156c-15.438,0-28-12.562-28-28s12.562-28,28-28,28,12.562,28,28-12.562,28-28,28Z"
      />
      <path
        fill={fill}
        d="M128,156c-15.438,0-28-12.562-28-28s12.562-28,28-28,28,12.562,28,28-12.562,28-28,28Z"
      />
      <path
        fill={fill}
        d="M208,156c-15.438,0-28-12.562-28-28s12.562-28,28-28,28,12.562,28,28-12.562,28-28,28Z"
      />
    </svg>
  )
}

export function collapse ({ height, width, fill, className }: IconOptions) {
  return (
    <svg
      height={height}
      width={width}
      className={className}
      viewBox="0 0 256 256"
    >
      <path
        fill={fill}
        d="m226.207 82.919-.017-.019c-5.937-6.547-16.057-7.04-22.602-1.102L128 150.367l-75.588-68.57c-6.546-5.938-16.666-5.444-22.602 1.102l-.017.019c-5.935 6.545-5.442 16.662 1.102 22.599l86.348 78.33c6.103 5.536 15.411 5.536 21.514 0l86.348-78.33c6.544-5.936 7.038-16.054 1.102-22.599Z"
      />
    </svg>
  )
}

export function arrowLeft ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path d="m161.905 202.207.019-.017c6.547-5.937 7.04-16.057 1.102-22.602L118.457 128l44.569-51.588c5.938-6.546 5.444-16.666-1.102-22.602l-.019-.017c-6.545-5.935-16.662-5.442-22.599 1.102l-54.33 62.348c-5.536 6.103-5.536 15.411 0 21.514l54.33 62.348c5.936 6.544 16.054 7.038 22.599 1.102Z" />
    </svg>
  )
}

export function fullArrowLeft ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <circle cx="128" cy="32" r="16" />
      <circle cx="128" cy="224" r="16" />
      <path
        fill={fill}
        d="M224 112H70.627l68.686-68.686c6.249-6.248 6.249-16.379 0-22.627-6.248-6.248-16.379-6.248-22.627 0l-95.999 95.999C17.791 119.582 16 123.582 16 128s1.791 8.418 4.687 11.314l96 96c6.248 6.248 16.379 6.248 22.627 0 6.249-6.248 6.249-16.379 0-22.627l-68.686-68.686H224c8.836 0 16-7.164 16-16s-7.164-16-16-16Z"
      />
    </svg>
  )
}

export function visible ({ height, width, fill, className }: IconOptions) {
  return (
    <svg
      className={className}
      height={height}
      width={width}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M128 36C57.308 36 0 97.054 0 128c0 32.943 57.308 92 128 92s128-59.057 128-92c0-30.946-57.308-92-128-92Zm75.346 131.751C190.404 178.301 163.406 196 128 196s-62.403-17.699-75.346-28.249C31.004 150.103 24 133.349 24 128c0-.047.071-4.846 6.247-14.452 5.34-8.308 13.341-17.061 22.527-24.648 6.833-5.643 17.521-13.282 31.163-19.291C71.664 81.27 64 97.734 64 116c0 35.346 28.654 64 64 64s64-28.654 64-64a63.79 63.79 0 0 0-5.004-24.847C186.913 106.546 174.413 119 159 119s-28-12.536-28-28c0-13.851 10.06-25.346 23.271-27.594 22.243 5.762 39.382 17.586 48.956 25.494 9.186 7.587 17.187 16.341 22.527 24.648 6.176 9.606 6.247 14.405 6.247 14.452 0 5.349-7.004 22.103-28.654 39.751Z"
      />
    </svg>
  )
}

export function hidden ({ height, width, fill, className = '' }: IconOptions) {
  return (
    <svg
      className={className}
      height={height}
      width={width}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M154.271 63.406c22.243 5.762 39.382 17.586 48.956 25.494 9.186 7.587 17.187 16.341 22.527 24.648 6.176 9.606 6.247 14.405 6.247 14.452 0 4.764-5.566 18.577-22.079 34.01l16.973 16.972c18.185-17.247 29.106-36.602 29.106-50.982 0-30.946-57.308-92-128-92-13.307 0-26.139 2.165-38.205 5.884l42.099 42.099c2.731-10.572 11.479-18.722 22.376-20.577Z"
      />
      <path
        fill={fill}
        d="m166.022 118.111 21.472 21.472A63.801 63.801 0 0 0 191.999 116a63.79 63.79 0 0 0-5.004-24.847c-.07 12.971-8.957 23.853-20.974 26.958ZM31.833 17.863c-4.687-4.686-12.284-4.686-16.971 0-4.686 4.687-4.686 12.285 0 16.971l29.92 29.92C17.38 84.825 0 110.966 0 128c0 32.943 57.308 92 128 92 21.088 0 40.972-5.269 58.51-13.52l37.657 37.657c4.687 4.686 12.284 4.686 16.971 0 4.686-4.687 4.686-12.285 0-16.971L31.833 17.863ZM128 196c-35.405 0-62.403-17.699-75.346-28.249C31.004 150.103 24 133.349 24 128c0-.047.071-4.846 6.247-14.452 5.34-8.308 13.341-17.061 22.527-24.648a134.832 134.832 0 0 1 9.205-6.95l7.708 7.708a63.612 63.612 0 0 0-5.686 26.343c0 35.346 28.654 64 64 64 9.397 0 18.31-2.043 26.345-5.684l13.936 13.936c-11.606 4.516-25.17 7.749-40.281 7.749Z"
      />
    </svg>
  )
}

// Camera
export function orbit ({ height, width, fill = '', className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M128 60.602c-.531 0-1.061.002-1.591.006-7.079.05-12.565 6.208-11.833 13.249.64 6.151 5.849 10.797 12.033 10.751.463-.003.926-.005 1.39-.005 29.699 0 58.4 6.563 78.743 18.006 16.051 9.029 25.257 19.961 25.257 29.994s-9.206 20.965-25.257 29.994c-20.343 11.443-49.044 18.006-78.743 18.006s-58.4-6.563-78.743-18.006c-16.051-9.028-25.257-19.961-25.257-29.994s9.206-20.965 25.257-29.994c2.522-1.419 5.189-2.751 7.957-4.015l-1.947 5.262c-1.787 4.831-1.549 11.646 5.003 14.956.328.166.661.314.997.446 5.46 2.136 11.577-.208 14.225-5.453l13.87-27.458c3.673-7.271.745-16.173-6.525-19.845L55.374 52.631a11.58 11.58 0 0 0-.996-.446c-5.459-2.135-11.576.209-14.225 5.452-2.772 5.493-.462 12.349 5.151 15.284l4.682 2.448.046.146C19.615 88.676 0 109.346 0 132.602c0 39.764 57.308 72 128 72s128-32.236 128-72-57.308-72-128-72Z"
      />
      <path
        fill={fill}
        fillRule="evenodd"
        d="M128 160.602c-15.44 0-28-12.561-28-28s12.56-28 28-28 28 12.561 28 28-12.56 28-28 28Z"
      />
    </svg>
  )
}

export function look ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="m221.08 221.465-60.889-33.212c13.199-17.151 20.56-38.386 20.56-60.253s-7.36-43.102-20.56-60.253l60.889-33.212c5.818-3.174 7.962-10.463 4.789-16.281-3.174-5.818-10.463-7.961-16.281-4.789l-190.668 104a12.002 12.002 0 0 0 0 21.07l190.667 104a11.999 11.999 0 0 0 16.281-4.789c3.173-5.818 1.029-13.107-4.789-16.281ZM49.727 128l89.041-48.567a74.846 74.846 0 0 1 6.321 8.582c-.113-.003-.225-.014-.338-.014-13.255 0-24 17.909-24 40s10.745 40 24 40c.113 0 .225-.012.338-.014a74.846 74.846 0 0 1-6.321 8.582l-89.041-48.567Z"
      />
    </svg>
  )
}

export function perspective ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="m228.729 46.855-188-37.961a34.146 34.146 0 0 0-6.75-.676C15.243 8.218 0 23.471 0 42.221v171.558c0 18.75 15.243 34.003 33.979 34.003 2.258 0 4.529-.227 6.75-.676l188-37.962c15.802-3.19 27.271-17.207 27.271-33.327V80.183c0-16.121-11.469-30.137-27.271-33.327ZM154 56.25v143.5l-52 10.5V45.75l52 10.5ZM35.979 223.581c-.674.136-1.343.201-2 .201-5.384 0-9.979-4.373-9.979-10.003V42.221c0-5.63 4.596-10.003 9.979-10.003.657 0 1.326.065 2 .201L78 40.904v174.192l-42.021 8.485ZM232 175.817a10 10 0 0 1-8.021 9.802L178 194.903V61.096l45.979 9.284A10 10 0 0 1 232 80.182v95.635Z"
      />
    </svg>
  )
}

export function orthographic ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M238.851 77.857v-2.31a20.002 20.002 0 0 0-10-17.321L138 5.774a19.991 19.991 0 0 0-20 0L27.149 58.226a20 20 0 0 0-10 17.321v104.906a20.002 20.002 0 0 0 10 17.321L118 250.227a19.991 19.991 0 0 0 20 0l90.851-52.453a20 20 0 0 0 10-17.321V77.857ZM128 27.713l74.852 43.216L128 114.145 53.148 70.929 128 27.713ZM41.149 91.714 116 134.929v86.43l-74.851-43.215v-86.43Zm173.702 86.43L140 221.359v-86.43l74.851-43.215v86.43Z"
      />
    </svg>
  )
}

export function camera ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        id="noun-walking-4952413"
        d="M136.693,8c-13.243,.037-23.948,10.802-23.911,24.044,.037,13.243,10.802,23.948,24.044,23.911,13.217-.037,23.912-10.761,23.912-23.978s-10.735-23.978-23.978-23.978c-.022,0-.045,0-.067,0Zm-13.867,54.936c-21.612,1.291-41.372,12.631-53.391,30.639-6.568,13.483-9.23,28.535-7.686,43.454,0,5.19,4.208,9.398,9.398,9.398s9.398-4.208,9.398-9.398c-1.308-11.482,.414-23.106,4.995-33.716,5.052-6.952,11.735-12.556,19.462-16.318-3.344,15.466-6.407,30.958-9.538,46.371l44.626,106.009c2.654,6.925,10.42,10.386,17.344,7.732,6.925-2.654,10.386-10.42,7.732-17.344-.104-.272-.217-.54-.339-.805l-35.901-85.255,4.569-19.076,3.344-13.974c9.591,17.424,31.878,22.14,47.117,25.763,5.051,1.188,10.108-1.943,11.296-6.994,1.188-5.051-1.943-10.108-6.994-11.296-11.472-1.392-22.38-5.765-31.638-12.682-3.628-3.641-6.363-8.073-7.993-12.948-2.198-6.128-3.224-12.882-5.182-18.929h0c-4.103-10.577-11.496-10.524-20.661-10.55l.04-.08Zm-30.292,84.443l-9.098,45.119-20.821,34.795c-3.996,6.247-2.171,14.551,4.076,18.547,6.247,3.996,14.551,2.171,18.547-4.076,.143-.224,.279-.452,.409-.684l22.646-37.859c1.207-2.015,1.864-4.312,1.905-6.661v-7.087l-17.717-42.108,.053,.013Z"
      />
    </svg>
  )
}

export function pan ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M195.493,44.007c-3.01-.07-5.896,.42-8.567,1.365v-.808c0-13.274-10.857-24.635-24.13-24.563-3.077,.017-6.014,.618-8.714,1.69-2.841-10.448-12.557-18.064-23.992-17.676-13.011,.442-23.164,11.483-23.164,24.501v.856c-2.671-.944-5.556-1.435-8.567-1.365-13.12,.305-23.433,11.398-23.433,24.521V127.111l-10.434-15.696c-4.696-6.464-12.014-9.895-19.436-9.895-4.891,0-9.828,1.49-14.087,4.585-10.724,7.791-13.101,22.8-5.31,33.523l54.159,86.902s.004,.006,.007,.009c.003,.005,0,.011,.003,.016,11.686,15.453,30.233,25.445,51.098,25.445h24c35.346,0,64-28.654,64-64V68.528c0-13.124-10.313-24.216-23.433-24.521Zm7.433,143.993c0,26.467-21.533,48-48,48h-24c-12.635,0-24.139-4.916-32.719-12.925-.696-.672-4.407-4.544-5.93-6.641l-53.673-86.21c-1.695-2.333-1.623-4.731-1.43-5.954,.194-1.222,.867-3.526,3.2-5.221,1.739-1.264,3.507-1.529,4.684-1.53,2.601,0,4.967,1.203,6.49,3.3l24.791,35.986c4.455,6.467,14.588,3.314,14.588-4.539V52.282c0-4.257,3.205-7.98,7.452-8.264,4.658-.312,8.548,3.389,8.548,7.982V121.065c0,4.261,3.215,7.981,7.467,8.257,4.659,.302,8.533-3.388,8.533-7.983V28.282c0-4.257,3.205-7.98,7.452-8.264,4.658-.312,8.548,3.389,8.548,7.982V113.065c0,4.261,3.215,7.981,7.467,8.257,4.659,.302,8.533-3.388,8.533-7.983V44.282c0-4.257,3.205-7.98,7.452-8.264,4.658-.312,8.548,3.389,8.548,7.982v85.065c0,4.261,3.215,7.981,7.467,8.257,4.659,.302,8.533-3.388,8.533-7.983v-61.057c0-4.257,3.205-7.98,7.452-8.264,4.658-.312,8.548,3.389,8.548,7.982v120Z"
      />
    </svg>
  )
}

export function zoom ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        id="Path_15078"
        d="M127.995,10c-.714,0-1.428,.033-2.137,.101s-1.417,.168-2.116,.302-1.38,.303-2.058,.505c-.673,.201-1.334,.437-1.982,.708l-54.032,22.533c-1.975,.805-3.791,1.954-5.363,3.395-1.377,1.262-2.474,2.799-3.219,4.511-.692,1.598-.977,3.343-.829,5.078,.177,1.813,.813,3.55,1.85,5.048,.755,1.105,1.672,2.091,2.72,2.925,1.09,.868,2.286,1.595,3.558,2.162,1.332,.597,2.726,1.047,4.156,1.339,1.483,.306,2.994,.46,4.509,.46,.73,0,1.463-.036,2.196-.107s1.466-.178,2.193-.323c.73-.144,1.452-.326,2.164-.544,.716-.22,1.42-.477,2.108-.771l28.901-12.348-9.857,153.04-42.33-21.972c-.749-.389-1.523-.729-2.316-1.019-.789-.289-1.595-.529-2.414-.719-.817-.189-1.643-.331-2.476-.425-.833-.094-1.67-.141-2.508-.14-1.627,0-3.248,.173-4.839,.515-1.582,.338-3.124,.846-4.598,1.513-1.465,.662-2.85,1.489-4.126,2.467-1.276,.976-2.421,2.111-3.41,3.378-1.425,1.804-2.445,3.894-2.989,6.127-.496,2.076-.514,4.238-.053,6.323,.476,2.111,1.419,4.088,2.759,5.786,1.478,1.86,3.329,3.389,5.434,4.49l80.749,43.116c.794,.422,1.614,.794,2.456,1.112,.84,.318,1.7,.584,2.573,.797,3.51,.849,7.171,.849,10.681,0,.873-.213,1.732-.479,2.573-.797,.841-.318,1.662-.689,2.456-1.112l80.733-43.116c2.105-1.101,3.955-2.631,5.433-4.49,1.34-1.698,2.283-3.676,2.759-5.786,.462-2.084,.443-4.246-.053-6.323-.545-2.234-1.564-4.323-2.989-6.127-.989-1.266-2.134-2.401-3.41-3.378-1.277-.977-2.661-1.805-4.126-2.467-1.474-.667-3.016-1.174-4.598-1.513-1.59-.342-3.211-.514-4.838-.515-.838,0-1.676,.046-2.508,.14-.833,.093-1.66,.235-2.476,.425-.819,.19-1.625,.429-2.414,.717-.793,.29-1.567,.631-2.316,1.02l-42.327,21.972-9.885-153.046,28.903,12.348c.689,.294,1.392,.552,2.108,.771,.712,.218,1.434,.399,2.165,.544,.728,.145,1.46,.252,2.192,.323s1.467,.107,2.196,.107c1.515,0,3.026-.153,4.51-.46,1.43-.293,2.824-.742,4.156-1.339,1.272-.568,2.467-1.295,3.557-2.162,1.048-.833,1.965-1.819,2.72-2.925,1.038-1.497,1.676-3.235,1.853-5.048,.148-1.731-.135-3.472-.824-5.068-.748-1.713-1.847-3.25-3.226-4.511-1.574-1.44-3.39-2.589-5.365-3.395l-54.024-22.537c-.648-.271-1.309-.507-1.982-.708-.671-.201-1.361-.37-2.06-.505s-1.401-.236-2.111-.302-1.423-.101-2.134-.101"
      />
    </svg>
  )
}

export function frameRect ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z"></path>
      <rect
        fill={fill}
        width="40"
        height="24"
        x="148"
        y="6.979"
        rx="10"
        ry="10"
      ></rect>
      <path
        fill={fill}
        d="M216 6.979h-10c-5.5 0-10 4.5-10 10v4c0 5.5 4.5 10 10 10a6 6 0 016 6c0 5.5 4.5 10 10 10h4c5.5 0 10-4.5 10-10v-10c0-11-9-20-20-20z"
      ></path>
      <rect
        fill={fill}
        width="24"
        height="40"
        x="212"
        y="54.979"
        rx="10"
        ry="10"
      ></rect>
      <rect
        fill={fill}
        width="40"
        height="24"
        x="52"
        y="6.979"
        rx="10"
        ry="10"
      ></rect>
      <rect
        fill={fill}
        width="40"
        height="24"
        x="52"
        y="214.979"
        rx="10"
        ry="10"
      ></rect>
      <rect
        fill={fill}
        width="40"
        height="24"
        x="100"
        y="6.979"
        rx="10"
        ry="10"
      ></rect>
      <path
        fill={fill}
        d="M24 6.979h10c5.5 0 10 4.5 10 10v4c0 5.5-4.5 10-10 10a6 6 0 00-6 6c0 5.5-4.5 10-10 10h-4c-5.5 0-10-4.5-10-10v-10c0-11 9-20 20-20z"
      ></path>
      <rect
        fill={fill}
        width="24"
        height="40"
        x="4"
        y="54.979"
        rx="10"
        ry="10"
      ></rect>
      <rect
        fill={fill}
        width="24"
        height="40"
        x="4"
        y="102.979"
        rx="10"
        ry="10"
      ></rect>
      <rect
        fill={fill}
        width="24"
        height="40"
        x="4"
        y="150.979"
        rx="10"
        ry="10"
      ></rect>
      <path
        fill={fill}
        d="M14 198.979h4c5.5 0 10 4.5 10 10a6 6 0 006 6c5.5 0 10 4.5 10 10v4c0 5.5-4.5 10-10 10H24c-11 0-20-9-20-20v-10c0-5.5 4.5-10 10-10zM188 154.979h-12v-12c0-4.4-3.6-8-8-8h-8c-4.4 0-8 3.6-8 8v12h-12c-4.4 0-8 3.6-8 8v8c0 4.4 3.6 8 8 8h12v12c0 4.4 3.6 8 8 8h8c4.4 0 8-3.6 8-8v-12h12c4.4 0 8-3.6 8-8v-8c0-4.4-3.6-8-8-8z"
      ></path>
      <path
        fill={fill}
        d="M252.5 229.872l-17.706-17.706A83.578 83.578 0 00248 166.979c0-46.392-37.608-84-84-84s-84 37.608-84 84 37.608 84 84 84c18.179 0 34.995-5.794 48.742-15.61l17.13 17.13c4.667 4.667 12.304 4.667 16.971 0l5.657-5.657c4.667-4.667 4.667-12.304 0-16.971zm-141.955-62.893c0-29.475 23.98-53.455 53.455-53.455s53.455 23.98 53.455 53.455-23.98 53.455-53.455 53.455-53.455-23.98-53.455-53.455z"
      ></path>
    </svg>
  )
}

export function frameSelection ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        d="M32,52c.032-11.032,8.968-19.968,20-20h28c4.418,0,8-3.582,8-8v-8c0-4.418-3.582-8-8-8h-28c-24.289,.027-43.973,19.711-44,44v28c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-28Z"
      />
      <path
        fill={fill}
        d="M32,204v-28c0-4.418-3.582-8-8-8h-8c-4.418,0-8,3.582-8,8v28c.027,24.289,19.711,43.973,44,44h28c4.418,0,8-3.582,8-8v-8c0-4.418-3.582-8-8-8h-28c-11.032-.032-19.968-8.968-20-20Z"
      />
      <path
        fill={fill}
        d="M224,204c-.032,11.032-8.968,19.968-20,20h-28c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h28c24.289-.027,43.973-19.711,44-44v-28c0-4.418-3.582-8-8-8h-8c-4.418,0-8,3.582-8,8v28Z"
      />
      <path
        fill={fill}
        d="M204,8h-28c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h28c11.032,.032,19.968,8.968,20,20v28c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-28c-.027-24.289-19.711-43.973-44-44Z"
      />
      <path
        fill={fill}
        d="M77.018,162.384l45.779,22.8c1.607,.801,3.406,1.225,5.203,1.225s3.596-.424,5.203-1.225l45.779-22.8c2.766-1.041,4.554-3.595,4.585-6.554l4.461-61.767,.005-.145c0-3.036-1.847-5.656-4.759-6.694l-53.103-17.293c-.702-.226-1.434-.341-2.172-.34-.738,0-1.47,.114-2.179,.343l-53.148,17.308c-2.859,1.021-4.706,3.641-4.706,6.677v.072l4.466,61.839c.031,2.959,1.819,5.513,4.585,6.554Zm89.894-12.383l-29.278,14.302v-45.521l31.595-12.086-2.316,43.305Zm-38.911-65.139l29.611,9.827-29.611,9.827-29.611-9.827,29.611-9.827Z"
      />
    </svg>
  )
}

// Isolation

// Measure
export function toggleIsolation ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M252 48V24c0-11-9-20-20-20h-24c-11 0-20 9-20 20H68c0-11-9-20-20-20H24C13 4 4 13 4 24v24c0 11 9 20 20 20v120c-11 0-20 9-20 20v24c0 11 9 20 20 20h24c11 0 20-9 20-20h120c0 11 9 20 20 20h24c11 0 20-9 20-20v-24c0-11-9-20-20-20V68c11 0 20-9 20-20Zm-40-20h16v16h-16V28ZM28 28h16v16H28V28Zm16 200H28v-16h16v16Zm184 0h-16v-16h16v16Zm-20-40c-11 0-20 9-20 20H68c0-11-9-20-20-20V68c11 0 20-9 20-20h120c0 11 9 20 20 20v120Z"
      />
      <path
        fill={fill}
        d="m183.274 87.225-53.103-17.293a7.053 7.053 0 0 0-2.172-.34c-.738 0-1.47.114-2.179.343L72.672 87.243c-2.859 1.021-4.706 3.641-4.706 6.677v.072l4.466 61.839c.031 2.959 1.819 5.513 4.585 6.554l45.779 22.8c1.607.801 3.406 1.225 5.203 1.225s3.596-.424 5.203-1.225l45.779-22.8c2.766-1.041 4.554-3.595 4.585-6.554l4.461-61.767.005-.145c0-3.036-1.847-5.656-4.759-6.694ZM128 104.517 98.389 94.69 128 84.863l29.611 9.827L128 104.517Zm38.911 45.484-29.278 14.302v-45.521l31.595-12.086-2.316 43.305Z"
      />
    </svg>
  )
}

// Measure
export function measure ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M248 8H8c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8V16c0-4.4-3.6-8-8-8Zm-16 120h-16V92c0-6.627-5.373-12-12-12s-12 5.373-12 12v36h-14V68c0-6.627-5.373-12-12-12s-12 5.373-12 12v60h-14V92c0-6.627-5.373-12-12-12s-12 5.373-12 12v36h-14V68c0-6.627-5.373-12-12-12s-12 5.373-12 12v60H64V92c0-6.627-5.373-12-12-12s-12 5.373-12 12v36H24V32h208v96ZM244 168c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12s12-5.373 12-12v-56c0-6.627-5.373-12-12-12ZM12 168c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12s12-5.373 12-12v-56c0-6.627-5.373-12-12-12ZM192.494 171.539c-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.971l7.505 7.506L72.97 196l7.49-7.49c4.687-4.686 4.687-12.284 0-16.971s-12.284-4.686-16.971 0l-27.976 27.976c-2.171 2.171-3.515 5.172-3.515 8.485s1.343 6.314 3.515 8.485l27.991 27.991c4.686 4.686 12.284 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.971l-7.505-7.506 110.059.016-7.49 7.49c-4.686 4.686-4.686 12.284 0 16.971 4.687 4.686 12.284 4.686 16.971 0l27.976-27.975c2.171-2.172 3.515-5.172 3.515-8.485s-1.343-6.314-3.515-8.485l-27.991-27.991Z"
      />
    </svg>
  )
}

// Section Box
export function sectionBox ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path
        fill={fill}
        d="m110.051 2.173-92.41 53.253a16.213 16.213 0 0 0-8.125 14.047V175.98a16.215 16.215 0 0 0 8.125 14.047l95.112 54.792c1.354.78 3.047-.195 3.047-1.756V121.339l105.613-60.862c1.354-.78 1.354-2.731 0-3.512L126.301 2.173a16.278 16.278 0 0 0-16.25 0ZM95.488 211.458l-65.659-37.82V82.577l65.66 37.82v91.062Zm10.266-107.741L40.096 65.898l78.08-44.996 65.66 37.819-78.081 44.996Z"
      />
      <path
        fill={fill}
        d="M138.483 135.324v118.658c0 1.551 1.682 2.521 3.028 1.745l96.896-55.839a16.117 16.117 0 0 0 8.076-13.961V74.25c0-1.551-1.682-2.521-3.028-1.745l-102.953 59.329a4.029 4.029 0 0 0-2.019 3.49Z"
      />
    </svg>
  )
}

export function sectionBoxClip ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <rect fill={fill} width="32" height="24" x="170" y="33" rx="10" ry="10" />
      <rect
        fill={fill}
        width="32"
        height="24"
        x="170"
        y="199"
        rx="10"
        ry="10"
      />
      <path
        fill={fill}
        d="M146 33.064h-2V11.997C144 5.371 138.627 0 132 0h-8c-6.627 0-12 5.371-12 11.997v21.067H32c-17.645 0-32 14.351-32 31.991v125.964c0 17.639 14.355 31.991 32 31.991h80v20.994c0 6.625 5.373 11.997 12 11.997h8c6.627 0 12-5.371 12-11.997V223.01h2c5.5 0 10-4.499 10-9.997v-3.999c0-5.498-4.5-9.997-10-9.997h-2V57.057h2c5.5 0 10-4.499 10-9.997v-3.999c0-5.498-4.5-9.997-10-9.997ZM32 199.016c-4.337 0-8-3.662-8-7.998V65.055c0-4.335 3.663-7.998 8-7.998h80v141.959H32ZM236 33h-10c-5.5 0-10 4.5-10 10v4c0 5.5 4.5 10 10 10a6 6 0 0 1 6 6c0 5.5 4.5 10 10 10h4c5.5 0 10-4.5 10-10V53c0-11-9-20-20-20Z"
      />
      <rect fill={fill} width="24" height="32" x="232" y="87" rx="10" ry="10" />
      <rect
        fill={fill}
        width="24"
        height="32"
        x="232"
        y="137"
        rx="10"
        ry="10"
      />
      <path
        fill={fill}
        d="M246 183h-4c-5.5 0-10 4.5-10 10a6 6 0 0 1-6 6c-5.5 0-10 4.5-10 10v4c0 5.5 4.5 10 10 10h10c11 0 20-9 20-20v-10c0-5.5-4.5-10-10-10Z"
      />
    </svg>
  )
}

export function sectionBoxIgnore ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M224 33h-80V11.963c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12V33H32C14.355 33 0 47.355 0 65v126c0 17.645 14.355 32 32 32h80v21.037c0 6.627 5.373 12 12 12h8c6.627 0 12-5.373 12-12V223h80c17.645 0 32-14.355 32-32V65c0-17.645-14.355-32-32-32ZM32 199c-4.337 0-8-3.663-8-8V65c0-4.337 3.663-8 8-8h80v142H32Zm200-8c0 4.337-3.663 8-8 8h-80V57h80c4.337 0 8 3.663 8 8v126Z"
      />
    </svg>
  )
}

export function sectionBoxReset ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill={fill}
        d="M250.744 223.115c-.002-.19.003-.379-.008-.571a12.236 12.236 0 0 0-.118-1.098c-.004-.026-.004-.052-.008-.078l-6.96-43.944c-1.037-6.547-7.185-11.013-13.731-9.976a11.966 11.966 0 0 0-7.833 4.799 11.963 11.963 0 0 0-2.145 8.932l2.427 15.326-22.708-16.498v-62.372a16 16 0 0 0-8-13.856L140 73.953V46.974l10.972 10.972c2.344 2.343 5.415 3.515 8.487 3.515s6.143-1.172 8.486-3.516c4.687-4.687 4.687-12.286 0-16.972l-31.46-31.46c-.019-.019-.039-.034-.058-.053a12.229 12.229 0 0 0-.819-.74c-.148-.122-.305-.228-.457-.342-.161-.12-.318-.245-.486-.357-.177-.119-.362-.222-.544-.331-.154-.092-.304-.188-.463-.273-.184-.098-.373-.182-.561-.27-.168-.079-.333-.163-.505-.234-.181-.075-.366-.136-.55-.202-.186-.066-.369-.138-.558-.195-.184-.055-.37-.096-.555-.143-.195-.049-.387-.104-.585-.143-.21-.042-.423-.066-.636-.097-.176-.025-.348-.059-.526-.076a12.166 12.166 0 0 0-2.368 0c-.178.018-.351.051-.526.076-.212.03-.425.055-.635.097-.2.04-.393.095-.589.144-.144.036-.289.063-.432.105l-.051.013c-.023.007-.045.017-.068.024-.191.058-.375.129-.562.196-.183.065-.367.126-.547.2-.174.072-.34.157-.51.237-.186.087-.373.17-.555.267-.161.086-.314.185-.471.278-.18.107-.362.209-.537.326-.17.114-.33.24-.493.362-.15.112-.304.217-.45.337-.286.235-.559.484-.821.743-.018.018-.038.033-.056.051l-31.46 31.46c-4.687 4.687-4.687 12.286 0 16.973 2.344 2.344 5.415 3.515 8.487 3.515s6.143-1.172 8.486-3.515l10.972-10.972v26.979l-51.66 29.826a16 16 0 0 0-8 13.856v62.475l-22.655 16.46 2.427-15.326c.518-3.274-.339-6.447-2.145-8.932s-4.559-4.281-7.833-4.799c-6.546-1.037-12.694 3.429-13.731 9.976l-6.96 43.944c-.004.026-.005.052-.008.078-.055.364-.096.73-.118 1.098-.011.192-.005.381-.008.571-.002.201-.011.402-.003.603.008.213.033.423.052.634.017.179.026.357.051.535.029.206.072.408.111.612.035.182.064.365.108.546.045.191.105.376.16.564.055.189.105.379.17.566.063.181.14.356.211.533.075.186.144.374.229.558.09.195.195.382.295.571.083.157.157.316.247.47.401.683.867 1.324 1.392 1.916.119.134.247.254.371.381.149.154.294.311.451.457.149.138.308.262.463.392.113.095.221.197.338.288.014.01.026.023.041.034.019.015.041.027.06.041.159.121.325.227.489.339.161.11.318.223.483.325.161.098.327.183.492.273.179.099.356.202.542.292.165.08.334.146.501.217.192.083.382.17.58.242.192.071.388.125.583.186.179.056.354.119.537.167.358.093.719.168 1.083.228.025.004.049.012.074.016l43.944 6.96c6.547 1.037 12.694-3.429 13.731-9.976a11.963 11.963 0 0 0-2.145-8.932 11.97 11.97 0 0 0-7.832-4.8l-15.326-2.427 22.838-16.593 49.369 28.503a15.989 15.989 0 0 0 16 0l49.448-28.549 22.812 16.574-15.326 2.427a11.962 11.962 0 0 0-7.832 4.8 11.963 11.963 0 0 0-2.145 8.932c1.037 6.547 7.185 11.013 13.731 9.976l43.944-6.96c.025-.004.049-.012.074-.016.364-.06.726-.135 1.083-.228.183-.048.358-.111.537-.167.195-.061.391-.115.583-.186.197-.073.387-.16.579-.242.167-.072.337-.138.501-.217.186-.09.363-.193.542-.292.165-.09.331-.175.492-.273.166-.102.323-.215.483-.325.164-.112.33-.219.489-.339l.06-.041c.014-.011.027-.024.041-.034.117-.091.225-.192.338-.288.155-.129.313-.253.463-.392.157-.145.302-.303.451-.457.124-.127.252-.247.371-.381a12.12 12.12 0 0 0 1.392-1.916c.09-.154.165-.313.247-.47.101-.19.206-.376.295-.571.084-.184.154-.371.229-.558.071-.177.147-.352.211-.533.064-.187.115-.377.17-.566.055-.188.115-.373.16-.564.043-.181.073-.364.108-.546.039-.204.082-.406.11-.612.025-.178.035-.356.051-.535.019-.211.044-.421.052-.634.008-.201 0-.402-.003-.603ZM91.443 115.843 128 94.737l36.556 21.105L128 136.947l-36.557-21.105Zm-11.104 21.302L116 157.733v40.145l-35.661-20.589v-40.144ZM140 197.877v-40.145l35.661-20.589v40.145L140 197.877Z"
      />
    </svg>
  )
}
export function sectionBoxShrink ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 256 256">
      <g data-name="FRAMES">
        <path fill="none" d="M0 0h256v256H0z" data-name="frame" />
      </g>
      <g data-name="ICONS">
        <path
          fill={fill}
          d="M191.661 82.008 136 49.872a15.991 15.991 0 0 0-16 0L64.339 82.008a16 16 0 0 0-8 13.856v64.272a16 16 0 0 0 8 13.856L120 206.128a15.991 15.991 0 0 0 16 0l55.661-32.136a16 16 0 0 0 8-13.856V95.864a16 16 0 0 0-8-13.856ZM128 72.966l36.556 21.105L128 115.176 91.443 94.071 128 72.965Zm-47.661 42.408L116 135.961v40.145l-35.661-20.589v-40.143ZM140 176.106v-40.145l35.661-20.589v40.145L140 176.106ZM228.971 212H240c6.627 0 12-5.373 12-12s-5.373-12-12-12h-40a11.963 11.963 0 0 0-8.485 3.515A11.963 11.963 0 0 0 188 200v40c0 6.627 5.373 12 12 12s12-5.373 12-12v-11.03l19.515 19.515c4.687 4.686 12.284 4.686 16.971 0 4.686-4.686 4.686-12.284 0-16.971l-19.515-19.515ZM44 228.971V240c0 6.627 5.373 12 12 12s12-5.373 12-12v-40c0-3.071-1.172-6.142-3.515-8.485A11.963 11.963 0 0 0 56 188H16c-6.627 0-12 5.373-12 12s5.373 12 12 12h11.03L7.515 231.515c-4.686 4.687-4.686 12.284 0 16.971 4.686 4.686 12.284 4.686 16.971 0l19.515-19.515ZM27.029 44H16C9.373 44 4 49.373 4 56s5.373 12 12 12h40c3.071 0 6.142-1.172 8.485-3.515A11.963 11.963 0 0 0 68 56V16c0-6.627-5.373-12-12-12S44 9.373 44 16v11.03L24.485 7.515c-4.687-4.686-12.284-4.686-16.971 0-4.686 4.686-4.686 12.284 0 16.971l19.515 19.515ZM212 27.029V16c0-6.627-5.373-12-12-12s-12 5.373-12 12v40c0 3.071 1.172 6.142 3.515 8.485A11.963 11.963 0 0 0 200 68h40c6.627 0 12-5.373 12-12s-5.373-12-12-12h-11.03l19.515-19.515c4.686-4.687 4.686-12.284 0-16.971-4.686-4.686-12.284-4.686-16.971 0l-19.515 19.515Z"
        />
      </g>
    </svg>
  )
}

export function ghost ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} width={height} height={width} viewBox="0 0 20 20">
      <g data-name="ICONS">
        <path
          d="M7.19 6.4955C6.47991 6.4955 5.90428 7.45488 5.90428 8.63837C5.90428 9.82186 6.47991 10.7812 7.19 10.7812C7.90009 10.7812 8.47572 9.82186 8.47572 8.63837C8.47572 7.45488 7.90009 6.4955 7.19 6.4955Z"
          fill={fill}
        />
        <path
          d="M11.0115 8.63837C11.0115 7.45488 11.5871 6.4955 12.2972 6.4955C13.0073 6.4955 13.583 7.45488 13.583 8.63837C13.583 9.82186 13.0073 10.7812 12.2972 10.7812C11.5871 10.7812 11.0115 9.82186 11.0115 8.63837Z"
          fill={fill}
        />
        <path
          d="M9.74357 0.000762939C5.30132 0.000762939 1.66666 3.63542 1.66666 8.07767V18.0777C1.66666 19.1354 2.27836 20.0008 3.5897 20.0008C4.23039 20.0008 4.61799 19.8172 5.01444 19.6293C5.42944 19.4328 5.85414 19.2316 6.589 19.2316C7.30908 19.2316 7.74211 19.4247 8.17416 19.6175C8.60425 19.8093 9.03336 20.0008 9.74366 20.0008C10.4921 20.0008 11.0123 19.7882 11.5057 19.5866C11.9509 19.4046 12.3744 19.2316 12.9243 19.2316C13.4865 19.2316 13.8951 19.4125 14.316 19.5988C14.763 19.7967 15.2239 20.0008 15.8975 20.0008C17.2053 20.0008 17.8206 19.1354 17.8206 18.0777V8.07767C17.8206 3.63533 14.1858 0.000762939 9.74357 0.000762939ZM3.80952 17.8216V8.07767C3.80952 6.50151 4.42926 5.01382 5.55444 3.88855C6.67963 2.76328 8.1674 2.14354 9.74357 2.14354C11.3197 2.14354 12.8074 2.76328 13.9327 3.88855C15.058 5.01382 15.6776 6.50151 15.6776 8.07767V17.832C15.5535 17.8014 15.4136 17.7414 15.1834 17.6394C14.6585 17.407 13.9396 17.0887 12.9242 17.0887C11.9534 17.0887 11.2261 17.3859 10.695 17.603C10.2624 17.7798 10.0579 17.8579 9.74357 17.8579C9.49892 17.8579 9.40508 17.8202 9.04714 17.6605C8.53668 17.4328 7.765 17.0886 6.589 17.0886C5.37252 17.0886 4.60528 17.452 4.09741 17.6925C3.95938 17.7579 3.87354 17.7977 3.80952 17.8216Z"
          fill={fill}
        />
      </g>
    </svg>
  )
}

export function ghostDead ({ height, width, fill, className }: IconOptions) {
  return (
    <svg className={className} width={height} height={width} viewBox="0 0 20 20">
      <g data-name="ICONS">
        <path
          d="M1.66666 8.07787C1.66666 3.63566 5.30128 0.00103311 9.74341 0.000854492C14.1856 0.000854492 17.8205 3.63557 17.8205 8.07787V18.0778C17.8205 19.1355 17.2053 20.0009 15.8975 20.0009C15.2239 20.0009 14.763 19.7968 14.316 19.5989C13.8951 19.4126 13.4865 19.2317 12.9243 19.2317C12.3744 19.2317 11.9508 19.4047 11.5056 19.5867C11.0122 19.7883 10.492 20.0009 9.74359 20.0009C9.03329 20.0009 8.60419 19.8094 8.17411 19.6176C7.74206 19.4248 7.30903 19.2317 6.58896 19.2317C5.8541 19.2317 5.42941 19.4328 5.01441 19.6294C4.61796 19.8172 4.23037 20.0009 3.58968 20.0009C2.27835 20.0009 1.66666 19.1355 1.66666 18.0778V8.07787ZM13.5284 6.73466L12.7791 7.48395L12.0298 6.73466C11.8705 6.57529 11.6615 6.49556 11.4526 6.49556C11.2437 6.49556 11.0347 6.57529 10.8754 6.73466C10.5566 7.05341 10.5566 7.57028 10.8754 7.88912L11.6246 8.63841L10.8754 9.38769C10.5566 9.70644 10.5566 10.2233 10.8754 10.5421C11.0347 10.7015 11.2437 10.7813 11.4526 10.7813C11.6615 10.7813 11.8705 10.7015 12.0298 10.5421L12.7791 9.79286L13.5284 10.5421C13.6878 10.7015 13.8967 10.7813 14.1056 10.7813C14.3145 10.7813 14.5235 10.7015 14.6828 10.5421C15.0016 10.2234 15.0016 9.70653 14.6828 9.38769L13.9336 8.63841L14.6828 7.88912C15.0016 7.57028 15.0016 7.05341 14.6828 6.73466C14.5235 6.57529 14.3145 6.49556 14.1056 6.49556C13.8967 6.49556 13.6878 6.57529 13.5284 6.73466ZM7.45699 6.73466L6.70771 7.48395L5.95842 6.73466C5.79905 6.57529 5.59012 6.49556 5.38119 6.49556C5.17227 6.49556 4.96334 6.57529 4.80396 6.73466C4.48522 7.05341 4.48522 7.57028 4.80396 7.88912L5.55325 8.63841L4.80396 9.38769C4.48522 9.70644 4.48522 10.2233 4.80396 10.5421C4.96334 10.7015 5.17227 10.7813 5.38119 10.7813C5.59012 10.7813 5.79905 10.7015 5.95842 10.5421L6.70771 9.79286L7.45699 10.5421C7.61636 10.7015 7.82529 10.7813 8.03422 10.7813C8.24315 10.7813 8.45207 10.7015 8.61145 10.5421C8.9302 10.2234 8.9302 9.70653 8.61145 9.38769L7.86216 8.63841L8.61145 7.88912C8.9302 7.57028 8.9302 7.05341 8.61145 6.73466C8.45207 6.57529 8.24315 6.49556 8.03422 6.49556C7.82529 6.49556 7.61636 6.57529 7.45699 6.73466Z"
          fill={fill}
        />
      </g>
    </svg>
  )
}
